import { Link } from 'react-router-dom';
import type { Video } from '@/types';
import { formatCount } from '@/utils/video';

interface VideoCardProps {
  video: Video;
  showAuthor?: boolean;
}

export default function VideoCard({ video, showAuthor = true }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block break-inside-avoid mb-4 cursor-pointer"
    >
      <div className="relative w-full aspect-[3/4] rounded-lg overflow-hidden bg-secondary-100">
        <img
          src={video.cover}
          alt={`${video.title} - 抖音短视频`}
          title={`${video.title} - 抖音短视频`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />

        {/* 顶部标签 */}
        {video.authorTag && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-[11px] font-medium">
            {video.authorTag}
          </span>
        )}

        {/* 底部渐变 + 时长 */}
        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-foreground-950/70 to-transparent" />
        <span className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-foreground-950/60 text-background-50 text-[11px] font-label">
          {video.duration}
        </span>

        {/* 悬停播放预览（PC 端） */}
        <div className="absolute inset-0 hidden md:flex flex-col items-center justify-center gap-2 bg-foreground-950/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="relative w-14 h-14 rounded-full bg-background-50/20 flex items-center justify-center">
            <span className="absolute inset-0 rounded-full bg-primary-500/60 animate-ping"></span>
            <i className="ri-play-fill text-3xl text-background-50 relative"></i>
          </span>
          <span className="text-background-50 text-xs font-medium">点击查看详情</span>
        </div>
      </div>

      <div className="mt-2.5">
        <h3 className="text-sm md:text-[15px] font-medium text-foreground-950 leading-snug line-clamp-2">
          {video.title}
        </h3>
        <div className="mt-1.5 flex items-center justify-between gap-2 text-xs text-foreground-500">
          {showAuthor ? (
            <span className="flex items-center gap-1 min-w-0">
              <span className="w-4 h-4 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center shrink-0">
                <i className="ri-user-3-line text-[10px]"></i>
              </span>
              <span className="truncate">{video.author}</span>
            </span>
          ) : (
            <span />
          )}
          <span className="flex items-center gap-1 shrink-0">
            <i className="ri-heart-3-line text-primary-500"></i>
            {formatCount(video.likes)}
          </span>
        </div>
      </div>
    </Link>
  );
}